module.exports = __webpack_public_path__ + "static/media/Violation tooth angulation4.718cc6aa.png";